<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="guiService.goTo('main/home')">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
<div class="container">
  <h2>{{"PROFILE.SUBS.PURCHASE-HISTORY-ADDON" | translate}}</h2>
  <span *ngIf="this.addons.length > 0 && !this.skeleton">
     <div class="addon info-box" *ngFor="let item of addons" (click)="openModalAddonsDetail(item.itemPrices)">
      <div class="d-flex">
        <p class="addon-title">
          {{item.itemPrices[0].i18nName[translate.currentLang.toUpperCase()]}}
          <span *ngIf="item.itemPrices.length > 1">(+{{ item.itemPrices.length - 1 }} {{ 'ADDONS.MORE' | translate }})</span>
        </p>
        <p class="purchase-date">{{item.purchaseDate | date: 'dd/MM/YY'}}</p>
      </div>

      <div class="d-flex mt-10">
        <p class="description">
          {{item.itemPrices[0].i18nDescription[translate.currentLang.toUpperCase()]}}
        </p>
        <p class="price">{{item.totalAmount +'$'}}</p>
      </div>
     </div>
  </span>
  <div *ngIf="this.addons.length === 0 && !this.skeleton">
    <p class="no-content">{{"ADDONS.NO-CONTENT" | translate}}</p>
  </div>
  <span *ngIf="this.skeleton">
    <ion-skeleton-text *ngFor="let item of skeletokPlaceholder" class="addon info-box" style="height: 83px;" [animated]="true"></ion-skeleton-text>
  </span>
</div>
